import { useCallback, useState } from "react";

/**
 * useSidebar — local UI + data state for the bugs/cases/incidents rail
 * on TseDashboard5. Kept separate from socket wiring; the parent calls
 * setBugs/setCases/setIncidents from tse:bugs / tse:cases events.
 */
export default function useSidebar() {
  const [bugs, setBugs] = useState([]);
  const [cases, setCases] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState("bugs");

  const toggleSidebar = useCallback(() => setIsExpanded((v) => !v), []);

  const expandToTab = useCallback((tab) => {
    setActiveTab(tab);
    setIsExpanded(true);
  }, []);

  const reset = useCallback(() => {
    setBugs([]);
    setCases([]);
    setIncidents([]);
  }, []);

  return {
    bugs,
    cases,
    incidents,
    isExpanded,
    activeTab,
    setBugs,
    setCases,
    setIncidents,
    toggleSidebar,
    setActiveTab,
    expandToTab,
    reset,
  };
}
